import React, {Fragment} from 'react';

import withClass from '../../../../hoc/withClass';
import NavigationItem from './NavigationItem/NavigationItem';

const navigationItems = () => (
    <Fragment>
        <ul className="site-menu" data-plugin="menu">
            <NavigationItem />
        </ul>
    </Fragment>
);

export default withClass(navigationItems, 'site-menubar-body');